import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import RfidTagCreate from '@/ui/pages/RfidTagCreate/RfidTagCreate';

export const Route = createFileRoute('/_dashboard/rfid-tags/new')({
  beforeLoad: requireRoute('/rfid-tags/new'),
  component: RfidTagCreate,
});
